/* ÉPURE · 360°-Ansicht
   Modus "flip": 2 Fotos (Front/Back) → Drehung per Ziehen, Front/Back-Wechsel bei 90°.
   Modus "seq":  8+ Fotos rundum (Dateiname enthält "360") → echte 360°-Bildfolge. */
function epure360(el) {
  if (el.__ep360) return; el.__ep360 = true;
  var mode = el.getAttribute('data-mode');
  var stage = el.querySelector('.ep-360__stage');
  var f = el.querySelector('.ep-360__f'), b = el.querySelector('.ep-360__b');
  var frameImg = el.querySelector('.ep-360__frame');
  var frames = mode === 'seq' ? (el.getAttribute('data-frames') || '').split('|').filter(Boolean) : [];
  var a = 0, v = 0, drag = false, lastX = 0, lastT = 0, raf = 0, target = null;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (mode === 'seq') frames.forEach(function (u) { var i = new Image(); i.src = u; });
  function norm(x) { return ((x % 360) + 360) % 360; }
  function render() {
    var n = norm(a);
    if (mode === 'seq' && frames.length) {
      var i = Math.round(n / 360 * frames.length) % frames.length;
      if (frameImg.getAttribute('data-i') !== String(i)) { frameImg.src = frames[i]; frameImg.setAttribute('data-i', i); }
    } else if (f && b) {
      var c = Math.cos(n * Math.PI / 180);
      var sx = 0.3 + 0.7 * Math.abs(c);
      var t = Math.min(1, Math.max(0, (c + 0.12) / 0.24));
      var tf = 'scaleX(' + sx.toFixed(3) + ')';
      f.style.transform = tf; b.style.transform = tf;
      f.style.opacity = t; b.style.opacity = 1 - t;
    }
    el.setAttribute('data-angle', Math.round(n));
  }
  function loop() {
    raf = 0;
    if (target !== null) { var d = target - a; if (Math.abs(d) < 0.4) { a = target; target = null; } else { a += d * 0.14; } }
    else if (!drag && Math.abs(v) > 0.05) { a += v; v *= 0.93; }
    render();
    if (target !== null || (!drag && Math.abs(v) > 0.05)) raf = requestAnimationFrame(loop);
  }
  function kick() { if (!raf) raf = requestAnimationFrame(loop); }
  function goTo(g) { var d = g - norm(a); if (d > 180) d -= 360; if (d < -180) d += 360; target = a + d; v = 0; kick(); }
  el.addEventListener('pointerdown', function (e) {
    if (e.target.closest('button')) return;
    drag = true; target = null; v = 0; lastX = e.clientX; lastT = performance.now();
    try { el.setPointerCapture(e.pointerId); } catch (err) {}
    el.classList.add('is-drag');
  });
  el.addEventListener('pointermove', function (e) {
    if (!drag) return;
    var dx = e.clientX - lastX, now = performance.now();
    a += dx * 0.5; v = dx * 0.5 / Math.max(1, (now - lastT) / 16);
    lastX = e.clientX; lastT = now; render();
  });
  function end() { if (!drag) return; drag = false; el.classList.remove('is-drag'); kick(); }
  el.addEventListener('pointerup', end); el.addEventListener('pointercancel', end);
  el.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
      e.preventDefault(); target = (target === null ? a : target) + (e.key === 'ArrowRight' ? 30 : -30); kick();
    }
  });
  Array.prototype.forEach.call(el.querySelectorAll('[data-ep-360-go]'), function (btn) {
    btn.addEventListener('click', function () { goTo(parseFloat(btn.getAttribute('data-ep-360-go')) || 0); });
  });
  render();
  if (!reduce && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      if (es[0].isIntersecting) { io.disconnect(); target = 50; kick(); setTimeout(function () { target = 0; kick(); }, 650); }
    }, { threshold: 0.5 });
    io.observe(el);
  }
}
window.epure360All = function epure360All() { Array.prototype.forEach.call(document.querySelectorAll('[data-ep-360]'), epure360); };

/* ÉPURE — Produktseite (Sticky, Grösse, Galerie) · assets/epure.js
   Nur zwei kleine Verbesserungen für die Produktseite. Ohne JavaScript funktioniert alles weiterhin.
   1) Sticky-Leiste (Mobile) ausblenden, solange der Haupt-Button sichtbar ist.
   2) Gewählte Grösse in der Sticky-Leiste anzeigen. */
(function () {
  function init(root) {
    if (root.__epInit) return; root.__epInit = true;
    var sticky = root.querySelector('[data-ep-sticky]');
    var buy = root.querySelector('[data-ep-buy]');
    if (sticky && buy && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { sticky.classList.toggle('is-off', e.isIntersecting); });
      }).observe(buy);
    }
    var label = root.querySelector('[data-ep-sticky-size]');
    root.querySelectorAll('input[type="radio"][name="id"]').forEach(function (r) {
      r.addEventListener('change', function () {
        if (label && r.checked) label.textContent = r.getAttribute('data-title') || '';
      });
    });
    var gal = root.querySelector('[data-ep-gallery]');
    var count = root.querySelector('[data-ep-count]');
    if (gal && count) {
      var total = gal.children.length;
      gal.addEventListener('scroll', function () {
        var i = Math.round(gal.scrollLeft / Math.max(gal.clientWidth, 1)) + 1;
        count.textContent = i + ' / ' + total;
      }, { passive: true });
    }
  }
  function run() { document.querySelectorAll('[data-ep-product]').forEach(init); if (window.epure360All) window.epure360All(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run); /* Theme-Editor */
})();

/* ÉPURE — Grössentabelle als Drawer (<dialog>)
   Link mit data-ep-dialog="ID" öffnet den Dialog. Ohne Dialog/JS: Link springt zum Akkordeon #ep-size-guide. */
(function () {
  function openAcc() { var d = document.getElementById('ep-size-guide'); if (d) d.open = true; }
  document.addEventListener('click', function (e) {
    var t = e.target;
    var a = t.closest && t.closest('[data-ep-dialog]');
    if (a) {
      var d = document.getElementById(a.getAttribute('data-ep-dialog'));
      if (d && typeof d.showModal === 'function') { e.preventDefault(); if (!d.open) d.showModal(); var c = d.querySelector('[data-ep-close]'); if (c) c.focus(); return; }
      if ((a.getAttribute('href') || '').indexOf('#ep-size-guide') === 0) openAcc();
      return;
    }
    var close = t.closest && t.closest('[data-ep-close]');
    if (close) { var dd = close.closest('dialog'); if (dd) dd.close(); return; }
    if (t.tagName === 'DIALOG' && t.classList.contains('ep-dlg')) t.close(); /* Klick auf den Hintergrund */
  });
  function hash() { if (location.hash === '#ep-size-guide') openAcc(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hash); else hash();
})();

/* ÉPURE — Intro Experience (sections/epure-intro.liquid)
   Video (muted/autoplay/playsinline) → Trigger (Sekunde X oder Videoende) → „001“ → Reveal des Hero.
   Autoplay blockiert → Standbild + „Play 001“. Enter/Esc → sofort zu Drop 001. Einmal pro Session. */
(function () {
  function init() {
    var el = document.getElementById('ep-intro');
    var root = document.documentElement;
    if (!el || el.__ep || el.classList.contains('ep-intro--static') || !root.classList.contains('ep-intro-on')) return;
    el.__ep = true;
    var v = el.querySelector('video');
    var play = el.querySelector('[data-ep-intro-play]');
    var skip = el.querySelector('[data-ep-intro-skip]');
    var key = el.getAttribute('data-key') || 'ep-intro';
    var trig = parseFloat(el.getAttribute('data-trigger')) || 0;
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    var done = false, started = false, raf = 0;

    function mark() { try { sessionStorage.setItem(key, '1'); } catch (e) {} }
    function focusHero() {
      var t = document.querySelector(el.getAttribute('data-target') || '#ep-hero');
      var h = t && (t.querySelector('h1') || t);
      if (h && h.focus) { try { h.focus({ preventScroll: true }); } catch (e) {} }
    }
    function remove() { if (el.parentNode) el.parentNode.removeChild(el); }
    /* mode: 'full' (nach dem Shirt-Moment), 'skip' (Enter), 'instant' (ohne Animation) */
    function finish(mode) {
      if (done) return; done = true; mark();
      if (raf) cancelAnimationFrame(raf);
      document.removeEventListener('keydown', onKey);
      window.scrollTo(0, 0);
      if (reduce || mode === 'instant') {
        try { v.pause(); } catch (e) {}
        root.classList.remove('ep-intro-on'); remove(); focusHero(); return;
      }
      var hold = mode === 'full' ? 340 : 0;
      if (mode === 'full') el.classList.add('is-cut'); /* Video weg, „001“ erscheint */
      setTimeout(function () {
        try { v.pause(); } catch (e) {}
        root.classList.add('ep-intro-reveal');
        root.classList.remove('ep-intro-on');
        el.classList.add('is-leaving');
      }, hold);
      setTimeout(function () { remove(); focusHero(); }, hold + 420);
      setTimeout(function () { root.classList.remove('ep-intro-reveal'); }, hold + 1200);
    }
    function showPlay() {
      if (done || started) return;
      play.hidden = false; el.classList.add('is-paused');
    }
    function watch() {
      if (done) return;
      if (trig > 0 && v.currentTime >= trig) { finish('full'); return; }
      raf = requestAnimationFrame(watch);
    }
    function onKey(e) { if (e.key === 'Escape') finish('skip'); }

    if (!v.getAttribute('src')) v.src = el.getAttribute('data-src') || el.getAttribute('data-src-d');
    if (!v.getAttribute('poster') && el.getAttribute('data-poster')) v.setAttribute('poster', el.getAttribute('data-poster'));
    v.muted = true;

    v.addEventListener('playing', function () {
      started = true; play.hidden = true;
      el.classList.remove('is-paused'); el.classList.add('is-playing');
      if (!raf) watch();
    });
    v.addEventListener('ended', function () { finish(reduce ? 'instant' : 'full'); });
    v.addEventListener('error', function () { started = false; showPlay(); setTimeout(function () { finish('skip'); }, 1400); });
    skip.addEventListener('click', function () { finish('skip'); });
    play.addEventListener('click', function () {
      play.hidden = true;
      var p = v.play();
      if (p && p.catch) p.catch(function () { finish('instant'); });
    });
    document.addEventListener('keydown', onKey);

    if (reduce) { v.preload = 'metadata'; showPlay(); return; }
    v.preload = 'auto';
    var p = v.play();
    if (p && p.catch) p.catch(showPlay);
    setTimeout(showPlay, 4000); /* langsames Netz: nach 4 s Play-Button zeigen */
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
